import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import config from '../../config';

import AdminImportPage from '../shared/adminImportPage.component';
import { adminPageNames, adminPageTitles } from '../shared/adminPageNames';

import AddLegalEntityModal from './addLegalEntityModal.component';

import {
  sharedActions,
} from './store/actions';

import { withPermissions, permissions } from '../../shared/authorization';
import { fromSearchString } from '../../shared/urlUtils';
import columnDefinitions, {
  importLegalEntitiesWithSourceColumnDefinitions,
} from '../../shared/columnDefinitions/legalEntities';
import { mergeColumnDefinitionsField } from '../../utils/columnDefinitionUtils';


import LegalEntitySettingsAdminColumnRenderer from './legalEntitySettingsAdminColumnRenderer.component';

import downloadLegalEntitiesXlsx from './downloadLegalEntitiesXlsx';
import { sortBySeverity } from '../../shared/sortBySeverity';

const columnDefinitionsWithDefaultSorting = mergeColumnDefinitionsField(['severity'], {
  sort: 'asc',
  comparator: (a, b) => sortBySeverity({ severity: a }, { severity: b }),
})(columnDefinitions);

const LegalEntitySettingsPage = ({
  canModifyInSelectedPeriod,
}) => {
  const { search } = useLocation();
  const generateTemplateFileName = useCallback(
    ({ periodName }) => `TLS_Legal_Entity_${periodName}`,
    []);
  const initialFilters = useMemo(() => ({
    legalEntity: fromSearchString(search, true)?.legalEntity,
  }), [search]);

  return (
    <>
      <AdminImportPage
        pageName={adminPageNames.LEGAL_ENTITIES}
        canModify={canModifyInSelectedPeriod}
        AddEditEntityModal={AddLegalEntityModal}
        adminColumnRenderer={LegalEntitySettingsAdminColumnRenderer}
        addEntityMessage="Add Legal Entity"
        importColumnDefs={importLegalEntitiesWithSourceColumnDefinitions}
        columnDefs={columnDefinitionsWithDefaultSorting}
        actions={sharedActions}
        exportToExcel={downloadLegalEntitiesXlsx}
        generateTemplateFileName={generateTemplateFileName}
        templatePath={config.templates.LEGAL_ENTITY}
        comparatorConfig={{
          idField: 'legalEntity',
        }}
        pageTitle={adminPageTitles.LEGAL_ENTITIES}
        initialFilters={initialFilters}
      />
      <ReactTooltip place="right" effect="float" />
    </>
  );
};

LegalEntitySettingsPage.propTypes = {
  canModifyInSelectedPeriod: PropTypes.bool.isRequired,
};

export default withPermissions(permissions.LEGAL_ENTITY_SETTINGS)(LegalEntitySettingsPage);
